import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { AuthDialogs } from './navbar/AuthDialogs';
import { ProfileDialog } from './navbar/ProfileDialog';
import { MobileMenu } from './navbar/MobileMenu';
import {
  IconButton,
  useTheme,
} from '@mui/material';
import { colors } from '../theme/theme';
import {
  Menu as MenuIcon,
} from '@mui/icons-material';
import { WhatsAppManageIcon } from './icons/WhatsAppManageIcon';
import { useAuth } from '../contexts/AuthContext';
import { doc, setDoc, getDoc, collection, query, where, onSnapshot, addDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { auth } from '../firebase';
import { updateEmail, updatePassword, reauthenticateWithCredential, EmailAuthProvider, verifyBeforeUpdateEmail } from 'firebase/auth';

interface UserProfile {
  firstName: string;
  lastName: string;
  nickname: string;
  city: string;
  team?: string;
}

interface FamilyMember {
  id: string;
  firstName: string;
  lastName: string;
  nickname: string;
}

const Navbar = () => {
  // Force update
  const {
    user,
    isAdmin,
    login,
    signup,
    resetPassword,
    openLogin
  } = useAuth();

  // Local state for dialogs (restored for performance)
  const [openProfileDialog, setOpenProfileDialog] = useState(false);
  const [openLoginDialog, setOpenLoginDialog] = useState(false);
  const [openRegisterDialog, setOpenRegisterDialog] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const theme = useTheme();

  // Listen for global auth events
  React.useEffect(() => {
    const handleLoginOpen = () => setOpenLoginDialog(true);
    const handleRegisterOpen = () => {
      setOpenLoginDialog(false);
      setOpenRegisterDialog(true);
    };

    window.addEventListener('auth-open-login', handleLoginOpen);
    window.addEventListener('auth-open-register', handleRegisterOpen);

    return () => {
      window.removeEventListener('auth-open-login', handleLoginOpen);
      window.removeEventListener('auth-open-register', handleRegisterOpen);
    };
  }, []);



  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  // Handlers for MobileMenu
  const handleOpenLogin = () => {
    openLogin();
  };





  return (
    <>
      <IconButton
        color="inherit"
        onClick={handleMobileMenuToggle}
        edge="start"
        sx={{
          position: 'fixed',
          top: theme.spacing(1),
          left: theme.spacing(2),
          zIndex: theme.zIndex.appBar,
          bgcolor: 'rgba(255,255,255,0.9)',
          borderRadius: '50%',
          p: 1.5,
          boxShadow: '0 0 15px rgba(0, 191, 255, 0.6), 0 0 30px rgba(0, 191, 255, 0.4)',
          border: '1px solid rgba(0, 191, 255, 0.3)',
          transition: 'all 0.3s ease-in-out',
          '&:hover': {
            bgcolor: '#fff',
            boxShadow: '0 0 20px rgba(0, 191, 255, 0.8), 0 0 40px rgba(0, 191, 255, 0.6)',
            transform: 'scale(1.1)'
          }
        }}
      >
        <MenuIcon sx={{ color: '#172a45', fontSize: 28 }} />
      </IconButton>
      <MobileMenu
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        onOpenProfile={() => setOpenProfileDialog(true)}
        onOpenLogin={openLogin}
      />

      <ProfileDialog
        open={openProfileDialog}
        onClose={() => setOpenProfileDialog(false)}
      />

      <AuthDialogs
        openLogin={openLoginDialog}
        onCloseLogin={() => setOpenLoginDialog(false)}
        openRegister={openRegisterDialog}
        onCloseRegister={() => setOpenRegisterDialog(false)}
        onOpenRegister={() => {
          setOpenLoginDialog(false);
          setOpenRegisterDialog(true);
        }}
      />
    </>
  );
};

export default Navbar;
